// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"528":"codemirror","909":"notifications","961":"returns"}[chunkId] + "." + {"528":"dfa074c280f51b270d7e","909":"263a736e8ee0fd6f0ad0","961":"d75e6b237e121862bcfc"}[chunkId] + ".css";
};